import type { TranslationMessages } from '../types';

export const project_management: TranslationMessages = {
  kanban_board: 'Bảng Kanban',
  gantt_chart: 'Biểu đồ Gantt',
  kanban_subtitle: 'Quản lý nhiệm vụ và theo dõi tiến độ',
  gantt_subtitle: 'Trực quan hóa thời gian và phụ thuộc dự án',
  kanban_implementation: 'Bảng Kanban - Đang triển khai',
  kanban_soon: 'Chức năng kéo và thả sẽ sớm có sẵn',
  gantt_implementation: 'Biểu đồ Gantt - Đang triển khai',
  gantt_soon: 'Trực quan hóa thời gian sẽ sớm có sẵn',
  create_task: 'Tạo Nhiệm vụ',
  edit_task: 'Chỉnh sửa Nhiệm vụ',
  delete_task: 'Xóa Nhiệm vụ',
  task_details: 'Chi tiết Nhiệm vụ',
  status: {
    todo: 'Cần làm',
    in_progress: 'Đang thực hiện',
    review: 'Xem xét',
    done: 'Hoàn thành',
    blocked: 'Bị chặn',
  },
  priority: {
    low: 'Thấp',
    medium: 'Trung bình',
    high: 'Cao',
    urgent: 'Khẩn cấp',
  },
  fields: {
    title: 'Tiêu đề',
    description: 'Mô tả',
    status: 'Trạng thái',
    priority: 'Ưu tiên',
    assignee: 'Người được giao',
    due_date: 'Ngày đến hạn',
    start_date: 'Ngày bắt đầu',
    estimated_hours: 'Giờ Ước tính',
    actual_hours: 'Giờ Thực tế',
    tags: 'Thẻ',
    dependencies: 'Phụ thuộc',
  },
  messages: {
    task_created: 'Tạo nhiệm vụ thành công',
    task_updated: 'Cập nhật nhiệm vụ thành công',
    task_deleted: 'Xóa nhiệm vụ thành công',
    confirm_delete: 'Bạn có chắc chắn muốn xóa nhiệm vụ này?',
    load_error: 'Không thể tải dữ liệu',
  },
  ai_autofill: 'AI Tự động điền',
  ai_refine: 'AI Tinh chỉnh',
  ai_enhance_tooltip: 'AI Nâng cấp: Tự động điền từ tiêu đề, hoặc tinh chỉnh dữ liệu hiện có',
  ai_autofill_tooltip: 'AI Tự động điền: Tự động điền tất cả các trường nhiệm vụ',
  ai_refine_tooltip: 'Tinh chỉnh các trường nhiệm vụ bằng AI dựa trên hướng dẫn của bạn',
  ai_autofill_success: 'Các trường nhiệm vụ đã được nâng cấp bằng AI',
  ai_autofill_error: 'Không thể nâng cấp các trường nhiệm vụ. Vui lòng thử lại.',
  ai_refine_success: 'Các trường nhiệm vụ đã được tinh chỉnh dựa trên hướng dẫn của bạn',
  ai_refine_error: 'Không thể tinh chỉnh các trường nhiệm vụ. Vui lòng thử lại.',
  ai_refine_dialog_title: 'AI Tinh chỉnh Nhiệm vụ',
  ai_refine_prompt_label: 'Hướng dẫn để AI tinh chỉnh',
  ai_refine_prompt_placeholder: 'ví dụ: "Làm mô tả chi tiết hơn", "Đặt mức ưu tiên cao", "Thêm thẻ cho phát triển frontend"',
  ai_refine_prompt_hint: 'Cung cấp hướng dẫn cụ thể về cách bạn muốn các trường nhiệm vụ được tinh chỉnh hoặc cải thiện.',
  ai_refine_prompt_required: 'Vui lòng cung cấp hướng dẫn để tinh chỉnh',
  delete_confirm_title: 'Xóa Nhiệm vụ',
  delete_confirm_desc: 'Bạn có chắc chắn muốn xóa nhiệm vụ này? Hành động này không thể hoàn tác.',
  select_assignee: 'Chọn người được giao...',
  add_tag_placeholder: 'Nhấn Enter để thêm thẻ',
};
